<template>
  <div
    v-if="status"
  >
    <b-card
      id="my-node"
      :class="`pl-2 mt-1  border-left-colorop${objetivo.orden} border-left-3`"
    >
      <b-row style="">
        <b-col sm="6" />
        <b-col
          sm="2"
          style="text-align: right;"
        >
          <h5>AÑO</h5>
        </b-col>
        <b-col
          sm="1"
          style="text-align: center;padding-bottom: 10px;"
        >
          <b-form-select
            v-model="selected"
            :options="optionsPeriodo"
            size="sm"
            @input="changeAnio"
          />
        </b-col>
        <b-col
          sm="2"
          style="text-align: right;"
        >
          <h5>FILTRO ACUMULADO</h5>
        </b-col>
        <b-col
          sm="1"
          style="text-align: center;"
        >
          <b-form-checkbox
            v-model="filterAcumulado"
            @input="changeFiltAcumulado"
          />
        </b-col>
        <!-- <b-col
          sm="1"
          style="text-align: center;"
        >
          <b-button
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="flat-success"
            class="btn-icon"
            @click="shotPic"
          >
            <feather-icon
              icon="PrinterIcon"
              size="25"
            />
          </b-button>
        </b-col> -->
        <b-col sm="4">
          <h2>
            <b-img
              style="width:11vh;height:11vh; margin-top: -1.5vh;"
              :src="require(`@/assets/images/prcp/op${objetivo.orden}.png`)"
            />
            <span style="padding-top: 5vh;"> OBJETIVO N° {{ objetivo.orden }} : <span :class="`colorop${objetivo.orden}`">
              {{ objetivo.descripcion }} </span></span> </h2>
          <b-col
            sm="12"
            style="padding-top: 1.5vh;"
          >
            <h4><strong>MEDIDA</strong> : {{ medida.descripcion }}</h4>
          <!-- <h4><strong>CONDUCTOR</strong> : {{ objetivo.representante }}</h4>
          <h4><strong>RESPONSABLE</strong> : PERSONA RESPONSABLE</h4>-->
          </b-col>
        </b-col>
        <b-col
          sm="3"
          style="justificate-conten : center;"
        >
          <b-row>
            <b-col
              sm="12"
              class="text-center mx-0"
            >
              <h5 style="font-weight: bolder;font-size: 16px;">
                Avance de la medida</h5>
              <b-row
                class="text-center mx-0"
                style="padding-left: 10vh;"
              >
                <vue-apex-charts
                  type="radialBar"
                  height="160"
                  width="150"
                  :options="chart.options"
                  :series="chart.series"
                />
              </b-row>
            </b-col>
          </b-row>

        </b-col>
        <b-col
          sm="3"
          style="justificate-conten : center;"
        >
          <b-row>
            <b-col
              sm="12"
              class="text-center mx-0"
            >
              <h5 style="font-weight: bolder;font-size: 16px;">
                Hitos Culminados</h5>
              <b-row
                class="text-center mx-0"
                style="padding-left: 10vh;"
              >
                <div
                  id="graficoAvance"
                  style="text-align: center;padding-top: 0.5vh;"
                />
              </b-row>
            </b-col>
          </b-row>

        </b-col>
        <!-- <b-col
          sm="2"
          style="text-align: right"
        >
          <b-form-select
            v-model="selected"
            :options="optionsPeriodo"
          />
        </b-col> -->
        <!-- <b-col sm="4">
          <b-card
            no-body
            class="card-browser-states"
          >
            <b-card-body>
              <b-card-title>INDICADORES DE LA MEDIDA</b-card-title>
              <b-row class="font-small-2">
                <b-col sm="6">
                  Actualización: 15 de noviembre de 2021.
                </b-col>
                <b-col
                  sm="6"
                  style="text-align: right;"
                >
                  <b-avatar
                    variant="danger"
                    size="sm"
                    text=" "
                  /> 0%-30%
                  <b-avatar
                    size="sm"
                    variant="warning"
                    text=" "
                  /> 30%-80%
                  <b-avatar
                    size="sm"
                    variant="success"
                    text=" "
                  /> 80%-100%
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-body
              style="max-height: 425px;overflow: auto;padding: 0.8rem;"
            >
              <b-list-group>
                <b-list-group-item
                  v-for="(indicador,index) in indicadores"
                  :key="index"
                  class="browser-states"
                  style="padding: 0px 10px;margin-top: 3px"
                >
                  <b-media no-body>
                    <b-media-body>
                      <h6 class="align-self-center my-auto">
                        {{ indicador.descripcion }}
                      </h6>
                    </b-media-body>
                  </b-media>
                  <div class="d-flex align-items-center">
                    <span class="font-weight-bold text-body-heading mr-1">{{ indicador.avance }}%</span>
                    <vue-apex-charts
                      type="radialBar"
                      height="50"
                      width="50"
                      :options="chartDataIndicador[index].options"
                      :series="chartDataIndicador[index].series"
                    />
                  </div></b-list-group-item>
              </b-list-group>
            </b-card-body>
          </b-card>
        </b-col> -->
      </b-row>
    </b-card>
    <b-row>
      <b-col>
        <b-card>
          <b-row class="font-small-2">
            <b-col sm="6">
              <h4 style="font-weight: bolder;font-size: 22px;">
                HITOS DE MEDIDA</h4>
            </b-col>
            <b-col
              sm="6"
              style="text-align: right;"
            >
              <b-avatar
                variant="danger"
                size="sm"
                text=" "
              /> 0%-30%
              <b-avatar
                size="sm"
                variant="warning"
                text=" "
              /> 30%-80%
              <b-avatar
                size="sm"
                variant="success"
                text=" "
              /> 80%-100%
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row sm="12">
      <b-col
        v-for="(hito,index) in hitos"
        :key="hito.medidaId"
        md="4"
        sm="4"
        class="mb-2"
      >
        <b-card class="align-items-center">
          <!-- <h3>MEDIDA {{ index+1 }}</h3>
            :style="`border: 4px solid #b8c2cc !important;border-radius: 16px;padding: 0.005em 2px 5px;`"
          -->
          <!-- <b-img
            style="width:80px;height:80px;"
            :src="require(`@/assets/images/prcp/op${index+1}.png`)"
          /> -->
          <b-row class="align-items-center">
            <b-col sm="12">
              <h5>
                <strong style="font-weight: bolder;font-size: 15px;">
                  CODIGO DE HITO :{{ hito.codigo }} </strong>
              </h5>
            </b-col>

            <b-col sm="8">
              <h5>
                <strong style="font-size: 17px">{{ hito.descripcion }} </strong>
              </h5>
            </b-col>
            <b-col sm="4">
              <vue-apex-charts
                type="radialBar"
                height="140"
                width="130"
                :options="chartData[index].options"
                :series="chartData[index].series"
              />
            </b-col>
            <b-col sm="6">
              Última actualización : {{ medida.fechaModificacion }}
            </b-col>
            <b-col
              sm="6"
              style="text-align: right;"
            >
              <div class="icon-wrapper">
                <feather-icon
                  icon="InfoIcon"
                  size="50"
                />
              </div>
            </b-col>
          </b-row>
          <!-- <div class="progress-wrapper mb-2">
                <b-card-text class="mb-1 mt-1">
                  Avance de la medida {{ medida.avance+'%' }}
                </b-card-text>
                <b-progress
                  :value="`${medida.avance}`"
                  max="100"
                  class="progress-bar-secondary"
                  :variant="`success op${index+1}`"
                />
              </div>
              La información se actualiza diariamente. Última actualización: 15 de noviembre de 2021.
              -->

          <!-- <div
            :id="`graficoAvanceMedida${index}`"
            style="text-align: center;padding-top: 5px;"
          /> -->
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BRow, BCol, BCard, BImg, BAvatar, BFormSelect, VBTooltip, BFormCheckbox,
} from 'bootstrap-vue'
// BCardTitle, BMedia, BMediaBody, BCardBody,BListGroup, BListGroupItem,
// BButton
import store from '@/store'
import router from '@/router'
import VueApexCharts from 'vue-apexcharts'
import ApexCharts from 'apexcharts'
import { $themeColors } from '@themeConfig'
import domtoimage from 'dom-to-image'
/* eslint-disable global-require */
const $trackBgColor = '#e9ecef'
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BImg,
    // BButton,
    VueApexCharts,
    // BCardTitle,
    // BMedia,
    // BMediaBody,
    // BCardBody,
    BAvatar,
    // BListGroup,
    // BListGroupItem,
    BFormSelect,
    BFormCheckbox,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      status: false,
      filterAcumulado: false,
      chtClassReport1: null,
      objetivo: {},
      avance: 0,
      pendiente: 0,
      medida: {},
      hitos: [],
      colorHito: '',
      tipoFiltro: '1',
      mes: '00',
      img: '',
      indicadores: [],
      chartColor: ['#8F5AA0', '#EABA18', '#63BCA6', '#5DB5E5', '#1D924C', '#E84462', '#6463A9', '#E96978', '#F08149'],
      chartData: [],
      chartDataIndicador: [],
      meses: [{ value: '00', text: 'TODOS' }, { value: '01', text: 'ENERO' }, { value: '02', text: 'FEBRERO' }, { value: '03', text: 'MARZO' }, { value: '04', text: 'ABRIL' }, { value: '05', text: 'MAYO' }, { value: '06', text: 'JUNIO' }, { value: '07', text: 'JULIO' }, { value: '08', text: 'AGOSTO' }, { value: '09', text: 'SEPTIEMBRE' }, { value: '10', text: 'OCTUBRE' }, { value: '11', text: 'NOVIEMBRE' }, { value: '12', text: 'DICIEMBRE' }],
      chartClone: {},
      chart: {
        series: [65],
        options: {
          stroke: {
            lineCap: 'round',
          },
          grid: {
            show: false,
            padding: {
              left: -15,
              right: -15,
              top: -12,
              bottom: -15,
            },
          },
          colors: [$themeColors.primary],
          plotOptions: {
            radialBar: {
              hollow: {
                size: '55%',
              },
              track: {
                background: $trackBgColor,
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: true,
                  offsetY: 3,
                  formatter(val) {
                    // eslint-disable-next-line radix
                    return `${(val).toFixed(1)}%`
                  },
                  fontSize: '1.5rem',
                  fontWeight: '600',
                },
              },
            },
          },
        },
      },
      chartHijo: {
        series: [65],
        options: {
          grid: {
            show: false,
            padding: {
              left: -15,
              right: -15,
              top: -12,
              bottom: -15,
            },
          },
          colors: [$themeColors.warning],
          plotOptions: {
            radialBar: {
              hollow: {
                size: '55%',
              },
              track: {
                background: $trackBgColor,
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: true,
                  offsetY: 3,
                  formatter(val) {
                    // eslint-disable-next-line radix
                    return `${parseInt(val)}%`
                  },
                  fontSize: '1.5rem',
                  fontWeight: '600',
                },
              },
            },
          },
          stroke: {
            lineCap: 'round',
          },
        },
      },
      selected: null,
      selectedAnio: '-1',
      optionsPeriodo: [],
      rangeDate: null,
      seriesPie: [44, 55, 13, 43, 22],
      chartOptionsPie: {
        chart: {
          width: 320,
          type: 'pie',
        },
        labels: [],
        responsive: [{
          breakpoint: 400,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        }],
        dataLabels: {
          name: {
            show: true,
          },
          value: {
            show: true,
            offsetY: 6,
            formatter(val) {
              // eslint-disable-next-line radix
              return `Hitos : ${parseInt(val)}`
            },
            fontSize: '2.5rem',
            fontWeight: '600',
          },
        },
      },
    }
  },
  async mounted() {
    await this.listPeriodo()
  },
  methods: {
    changeAnio(data) {
      console.log(data)
      console.log(this.selectedAnio)
      this.selectedAnio = data
      this.chtClassReport1 = null
      this.detalleObjetivo()
    },
    changeMes(data) {
      console.log(data)
    },
    async detalleObjetivo() {
      this.status = false
      const idMedida = Number(router.currentRoute.params.id)
      await store.dispatch('gsseguimiento/REPORTE_MEDIDA_DETALLE', { id: idMedida, anio: this.selectedAnio, tipoFiltro: this.tipoFiltro })
        .then(response => {
          this.avance = response.avance
          this.objetivo = response.objetivo
          this.medida = response.medida
          this.hitos = response.hitos
          this.indicadores = response.indicadores
          this.chart.series[0] = response.avance
          this.chart.options.colors[0] = this.chartColor[response.objetivo.orden - 1]
          // console.info('this.chart', this.chart)
          this.avanceMedidaHitos()
          // this.avanceMedidaIndicadores()
          this.status = true
        }).catch(error => {
          console.log(error)
          // this.$bvToast.toast(error, {
          //   title: 'He ocurrido un error',
          //   variant: 'danger',
          //   solid: true,
          // })
        })
      await this.avanceObjetivo()
    },
    listObjetivoDetalle(periodoId) {
      store.dispatch('gsseguimiento/ANIO_PERIODO_ALL', { periodo: periodoId })
        .then(response => {
          this.optionsPeriodo.push({ value: '-1', text: 'TODOS' })
          response.forEach(element => {
            this.optionsPeriodo.push({ value: element, text: element })
          })
          this.selected = -1
        }).catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    avanceObjetivo() {
      if (this.chtClassReport1 !== null) {
        this.chtClassReport1.destroy()
      }
      let concluidas = 0
      let pendientes = 0
      this.hitos.forEach(element => {
        if (element.avance === 100) {
          concluidas += 1
        } else {
          pendientes += 1
        }
      })
      const data = [
        { id: 1, total: concluidas, descripcion: 'Concluidos' },
        { id: 2, total: pendientes, descripcion: 'Pendientes' },
      ]
      const r1 = []
      const r2 = []
      data.forEach(dat => {
        r1.push(dat.total)
        r2.push(dat.descripcion)
      })
      this.chartOptionsPie.series = r1
      this.chartOptionsPie.labels = r2
      this.chartOptionsPie.colors = ['#148A4D', '#0F5396']
      // console.log(this.chartOptionsPie)
      this.chtClassReport1 = new ApexCharts(document.querySelector('#graficoAvance'), this.chartOptionsPie)
      this.chtClassReport1.render()
    },

    avanceMedidaHitos() {
      this.chartData = []
      for (let i = 0; i < this.hitos.length; i += 1) {
        const chartClone = JSON.parse(JSON.stringify(this.chartHijo))
        // const randow = Math.floor(Math.random() * (7 - 1 + 1)) + 1
        this.colorHito = $themeColors.danger
        if (this.hitos[i].avance > 30) { this.colorHito = $themeColors.warning }
        if (this.hitos[i].avance > 80) { this.colorHito = $themeColors.success }
        chartClone.options.colors[0] = this.colorHito
        chartClone.series[0] = this.hitos[i].avance
        this.chartData.push(chartClone)
        // console.info(`chartData${i}`, chartClone)
      }
    },
    avanceMedidaIndicadores() {
      for (let i = 0; i < this.indicadores.length; i += 1) {
        const chartClone = JSON.parse(JSON.stringify(this.chartHijo))
        // const randow = Math.floor(Math.random() * (7 - 1 + 1)) + 1
        this.colorHito = $themeColors.danger
        if (this.indicadores[i].avance > 30) { this.colorHito = $themeColors.warning }
        if (this.indicadores[i].avance > 80) { this.colorHito = $themeColors.success }
        chartClone.options.colors[0] = this.colorHito
        chartClone.series[0] = this.indicadores[i].avance
        this.chartDataIndicador.push(chartClone)
        // console.info(`chartDataIndicador${i}`, chartClone)
      }
    },
    async listPeriodo() {
      await store.dispatch('gsseguimiento/PERIODO_ALL_FIND', { periodo: -1 })
        .then(response => {
          //  { value: null, text: 'PERIODO' }
          // for (let i = 0; i < response.length; i += 1) {
          //   this.optionsPeriodo.push({ value: response[i].periodoId, text: response[i].descripcion })
          // }
          this.selected = response[response.length - 1].periodoId
          this.selectedId = response[response.length - 1].periodoId
          this.detalleObjetivo()
        }).catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
      await this.listObjetivoDetalle(this.selected)
    },
    changeFiltAcumulado() {
      if (this.filterAcumulado) {
        this.tipoFiltro = '2'
        if (this.selectedAnio !== '-1') {
          this.detalleObjetivo()
        }
      } else {
        this.tipoFiltro = '1'
        this.detalleObjetivo()
      }
    },
    shotPic() {
      const node = document.getElementById('my-node')
      console.log(node)
      domtoimage.toPng(node)
        .then(dataUrl => {
          console.log(dataUrl)
          this.img = dataUrl
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}

// chartOptionsReport1: {
//         series: [],
//         chart: {
//           width: 230,
//           type: 'pie',
//           events: {},
//         },
//         labels: [],
//         responsive: [{
//           breakpoint: 200,
//           options: {
//             chart: {
//               width: 180,
//             },
//             legend: {
//               position: 'top',
//             },
//           },
//         }],
//         legend: {
//           show: true,
//           position: 'bottom',
//           horizontalAlign: 'center',
//           floating: false,
//           fontSize: '12px',
//           fontFamily: 'Helvetica, Arial',
//           fontWeight: 400,
//           formatter: undefined,
//           inverseOrder: false,
//           width: undefined,
//           height: undefined,
//           tooltipHoverFormatter: undefined,
//           customLegendItems: [],
//           offsetX: 0,
//           offsetY: 0,
//           labels: {
//             colors: undefined,
//             useSeriesColors: false,
//           },
//           markers: {
//             width: 12,
//             height: 12,
//             strokeWidth: 0,
//             strokeColor: '#fff',
//             fillColors: undefined,
//             radius: 15,
//             customHTML: undefined,
//             onClick: undefined,
//             offsetX: 12,
//             offsetY: 0,
//           },
//           itemMargin: {
//             horizontal: 7,
//             vertical: 0,
//           },
//           onItemClick: {
//             toggleDataSeries: true,
//           },
//           onItemHover: {
//             highlightDataSeries: true,
//           },
//         },
//         dataLabels: {
//           enabled: true,
//           enabledOnSeries: undefined,
//           textAnchor: 'middle',
//           distributed: false,
//           offsetX: 0,
//           offsetY: 0,
//           style: {
//             fontSize: '14px',
//             fontFamily: 'Helvetica, Arial, sans-serif',
//             fontWeight: 'bold',
//             colors: undefined,
//           },
//           background: {
//             enabled: true,
//             foreColor: '#fff',
//             padding: 4,
//             borderRadius: 2,
//             borderWidth: 1,
//             borderColor: '#fff',
//             opacity: 0.9,
//             dropShadow: {
//               enabled: false,
//               top: 2,
//               left: 5,
//               blur: 1,
//               color: '#000',
//               opacity: 0.45,
//             },
//           },
//           dropShadow: {
//             enabled: false,
//             top: 1,
//             left: 1,
//             blur: 1,
//             color: '#000',
//             opacity: 0.45,
//           },
//         },
//       },
</script>
<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';

.colorop1{
  color: #8F5AA0 !important;
}
.colorop2 {
  color: #EABA18 !important;
}
.colorop3 {
  color: #63BCA6 !important;
}
.colorop4 {
  color: #5DB5E5 !important;
}
.colorop5 {
  color: #1D924C !important;
}
.op6 {
  color: #E84462 !important;
}
.colorop7 {
  color: #6463A9 !important;
}
.colorop8 {
  color: #E96978 !important;
}
.colorop9 {
  color: #F08149 !important;
}

.border-left-colorop1 {
  border-color: 1px solid #8F5AA0;
}
.border-left-colorop2 {
   border-left: 1px solid #EABA18;
}
.border-left-colorop3 {
  border-left: 1px solid #63BCA6;
}
.border-left-colorop4 {
   border-left: 1px solid #5DB5E5;
}
.border-left-colorop5 {
   border-left: 1px solid #1D924C;
}
.border-left-colorop6 {
   border-left: 1px solid #E84462;
}
.border-left-colorop7 {
   border-left: 1px solid #6463A9;
}
.border-left-colorop8 {
   border-left: 1px solid #E96978;
}
.border-left-colorop9 {
   border-left: 1px solid #F08149;
}

.centrate{
  text-align: center;
}
.card-body{
  padding-bottom: 5px;
}

</style>
